import './components/Clock.js'

import externalLinks from './lib/external-links.js'
externalLinks()

import vhCheck from 'vh-check'
const vhCheckResult = vhCheck()